import Alert from "@mui/material/Alert";
import React, { useState, useEffect } from "react";
import { TkPropertyMessageGet } from "../../../utils/TkPropertyMessageGet";
import { IErrorBarProps } from "../../../type/componentsType/TkMessageBar";
import "./_style.scss";

/**
 * メッセージバー部品
 * 受け取ったメッセージIDに対応するメッセージバーを表示する
 * @param id : メッセージID
 * @return HandleErrorMessage メッセージバー部品
 **/
const HandleErrorMessage: React.FC<IErrorBarProps> = (props) => {
  const { id, value } = props;
  let message: string;
  const [alert, setAlert] = useState(false);
  const [severity, setSeverity] = useState<"error" | "warning" | "info">(
    "error"
  );
  const [showMessage, setMessage] = useState("");
  const str = id.charAt(id.length - 1);

  const messageWithValue = ["TKMSG_SVR0024E", "TKMSG_SVR0200E"];

  if (messageWithValue.includes(id)) {
    message = TkPropertyMessageGet(id, value);
  } else {
    message = TkPropertyMessageGet(id);
  }
  useEffect(() => {
    if (id === "") {
      setAlert(false);
    } else {
      setAlert(true);
      if (str === "E") {
        setSeverity("error");
        setMessage(`エラー ${message}【${id}】`);
      } else if (str === "W") {
        setSeverity("warning");
        setMessage(`警告 ${message}【${id}】`);
      } else if (str === "I") {
        setSeverity("info");
        setMessage(`情報 ${message}【${id}】`);
      } else {
        setAlert(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return alert ? (
    <Alert data-testid="tkMsgForTest" severity={severity}>
      {showMessage}
    </Alert>
  ) : (
    <></>
  );
};
export default HandleErrorMessage;
